import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';

export default function AuthLayout({ heading, children }) {
    return (
        <div>
            <div className="registration-header">
                <h3><Translate id={heading} /></h3>
            </div>
            <div>{children}</div>
        </div>
    );
}

AuthLayout.propTypes = {
    heading: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};
